import React, { FC, useMemo } from 'react'
import styles from './icon.module.scss'
import classNames from 'classnames'

interface Props extends React.HTMLAttributes<HTMLElement> {
  type: string
  size?: string | number
  onClick?(e: React.MouseEvent): void
}

const Icon: FC<Props> = ({ size, type, onClick, className, ...restProps }) => {
  const iconStyle = useMemo(() => {
    const style = {} as React.CSSProperties
    if (size) {
      style.fontSize = `${size}px`
    }
    return style
  }, [size])

  return (
    <i
      className={classNames(styles.svgIcon, className)}
      style={iconStyle}
      onClick={onClick}
      {...restProps}
    >
      <svg className={styles.svgIconInner} aria-hidden="true">
        <use xlinkHref={`#icon-${type}`} /> {/* 修复：添加 icon- 前缀 */}
      </svg>
    </i>
  )
}

export default Icon
